import { ModalId } from '@heidi/schema/ml-scribe';
import dynamic from 'next/dynamic';
import { type ReactElement } from 'react';
import { useSessionMergeOnboardingUiHost } from '../../host';

import type { SessionMergeEducationModal as SessionMergeEducationModalType } from './session-merge-education-modal';

const SessionMergeEducationModal = dynamic<
  React.ComponentProps<typeof SessionMergeEducationModalType>
>(
  () =>
    import('./session-merge-education-modal').then((m) => ({
      default: m.SessionMergeEducationModal,
    })),
  { ssr: false }
);

/**
 * Code-splits the education modal so its bundle only loads once the queue
 * surfaces it. Mirrors `LazyWebDictationOnboardingModal`.
 */
export function LazySessionMergeEducationModal(): ReactElement | null {
  const { useQueuedModal } = useSessionMergeOnboardingUiHost();
  const { isOpen } = useQueuedModal(ModalId.SESSION_MERGE_EDUCATION);
  return isOpen ? <SessionMergeEducationModal /> : null;
}
